var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_637_2084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.504639,
    y: 0.223633,
    width: 72,
    height: 72,
    rx: 24,
    fill: "url(#paint0_linear_637_2084)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.754639,
    y: 0.473633,
    width: 71.5,
    height: 71.5,
    rx: 23.75,
    stroke: "url(#paint1_linear_637_2084)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5867 18.2682V16.0283C41.5867 15.6513 41.2822 15.3469 40.9052 15.3469H39.248V13.2723C39.248 12.8953 38.9435 12.5908 38.5685 12.5908H35.6048C35.2278 12.5908 34.9234 12.8953 34.9234 13.2723V15.3469H33.2661C32.8911 15.3469 32.5867 15.6513 32.5867 16.0283V18.2682C24.3488 20.2924 18.2197 27.738 18.2197 36.5908C18.2197 46.994 26.6834 55.4578 37.0867 55.4578C47.4899 55.4578 55.9536 46.994 55.9536 36.5908C55.9536 27.738 49.8226 20.2924 41.5867 18.2682ZM36.2843 13.9517H37.8891V15.3469H36.2843V13.9517ZM33.9476 16.7078H40.2258V17.988C39.2036 17.8146 38.1552 17.7239 37.0867 17.7239C36.0161 17.7239 34.9677 17.8146 33.9476 17.988V16.7078ZM37.0867 54.0969C27.4334 54.0969 19.5806 46.244 19.5806 36.5908C19.5806 26.9376 27.4334 19.0848 37.0867 19.0848C46.7399 19.0848 54.5927 26.9376 54.5927 36.5908C54.5927 46.244 46.7399 54.0969 37.0867 54.0969ZM37.7661 57.244V59.9114C37.7661 60.2864 37.4617 60.5908 37.0867 60.5908C36.7117 60.5908 36.4072 60.2864 36.4072 59.9114V57.244C36.4072 56.869 36.7117 56.5646 37.0867 56.5646C37.4617 56.5646 37.7661 56.869 37.7661 57.244ZM20.1169 20.5828C19.8508 20.3166 19.8508 19.8872 20.1149 19.6211C20.381 19.3549 20.8125 19.3549 21.0786 19.6211L22.9637 21.5061C23.2278 21.7723 23.2278 22.2017 22.9637 22.4678C22.8306 22.6009 22.6552 22.6674 22.4818 22.6674C22.3084 22.6674 22.133 22.6009 22.002 22.4678L20.1169 20.5828ZM17.1129 36.5908C17.1129 36.9658 16.8084 37.2723 16.4334 37.2723H13.7661C13.3911 37.2723 13.0867 36.9658 13.0867 36.5908C13.0867 36.2158 13.3911 35.9114 13.7661 35.9114H16.4334C16.8084 35.9114 17.1129 36.2158 17.1129 36.5908ZM51.2097 22.4678C50.9435 22.2017 50.9435 21.7723 51.2097 21.5061L53.0947 19.6211C53.3609 19.3549 53.7923 19.3549 54.0564 19.6211C54.3226 19.8872 54.3226 20.3166 54.0564 20.5828L52.1713 22.4678C52.0383 22.6009 51.8649 22.6674 51.6915 22.6674C51.5161 22.6674 51.3427 22.6009 51.2097 22.4678ZM22.9637 50.7138C23.2278 50.9799 23.2278 51.4114 22.9637 51.6755L21.0786 53.5626C20.9455 53.6936 20.7701 53.7602 20.5968 53.7602C20.4234 53.7602 20.248 53.6936 20.1149 53.5626C19.8508 53.2965 19.8508 52.865 20.1169 52.5989L22.002 50.7138C22.2661 50.4497 22.6976 50.4497 22.9637 50.7138ZM61.0867 36.5908C61.0867 36.9658 60.7822 37.2723 60.4072 37.2723H57.7399C57.3649 37.2723 57.0605 36.9658 57.0605 36.5908C57.0605 36.2158 57.3649 35.9114 57.7399 35.9114H60.4072C60.7822 35.9114 61.0867 36.2158 61.0867 36.5908ZM54.0564 52.5989C54.3226 52.865 54.3226 53.2965 54.0564 53.5626C53.9234 53.6936 53.75 53.7602 53.5766 53.7602C53.4012 53.7602 53.2278 53.6936 53.0947 53.5626L51.2097 51.6755C50.9435 51.4114 50.9435 50.9799 51.2097 50.7138C51.4758 50.4497 51.9052 50.4497 52.1713 50.7138L54.0564 52.5989ZM39.1431 24.0949C38.7137 23.3489 37.9435 22.9033 37.0867 22.9033C36.2278 22.9033 35.4597 23.3489 35.0282 24.0949L25.3367 40.8832C24.9052 41.6271 24.9052 42.5162 25.3347 43.2582C25.7641 44.0021 26.5343 44.4457 27.3931 44.4457H46.7782C47.6391 44.4457 48.4092 44.0021 48.8387 43.2582C49.2681 42.5162 49.2661 41.6271 48.8367 40.8832L39.1431 24.0949ZM47.6613 42.5787C47.4778 42.8953 47.1472 43.0848 46.7782 43.0848H27.3931C27.0242 43.0848 26.6955 42.8953 26.5121 42.5787C26.3286 42.2622 26.3306 41.8811 26.5141 41.5626L36.2076 24.7743C36.3911 24.4557 36.7197 24.2642 37.0867 24.2642C37.4516 24.2642 37.7802 24.4557 37.9657 24.7743L47.6572 41.5626C47.8427 41.8811 47.8427 42.2622 47.6613 42.5787ZM36.4072 37.1694V29.7461C36.4072 29.3711 36.7117 29.0666 37.0867 29.0666C37.4617 29.0666 37.7661 29.3711 37.7661 29.7461V37.1694C37.7661 37.5444 37.4617 37.8489 37.0867 37.8489C36.7117 37.8489 36.4072 37.5444 36.4072 37.1694ZM37.8972 39.6896C37.8972 40.1372 37.5343 40.5001 37.0867 40.5001C36.6391 40.5001 36.2762 40.1372 36.2762 39.6896C36.2762 39.242 36.6391 38.8791 37.0867 38.8791C37.5343 38.8791 37.8972 39.242 37.8972 39.6896Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_637_2084",
    x: -19.4954,
    y: -19.7764,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_637_2084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_637_2084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_2084",
    x1: 36.5046,
    y1: 0.223633,
    x2: 36.5046,
    y2: 72.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_637_2084",
    x1: 36.5046,
    y1: 0.223633,
    x2: 36.5046,
    y2: 72.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.0e9dbb19baedb556652799ca69556fd4.svg";
export { ForwardRef as ReactComponent };